import React from 'react';
import { IDetailPageOpenSeaDragon } from 'src/pages/DetailPage/components/DetailPageOpenSeaDragon.i';
import { NRAFFFOSDOverlay } from 'src/pages/DetailPage/components/DetailPageOpenSeaDragon.style';
import { DetailPageOpenSeaDragonViewer } from 'src/pages/DetailPage/DetailPage.style';
import NRAFFFLogo from 'images/NRAFFF LOGO-2.png';

export const DetailPageOpenSeaDragon = ({ auctionId, photo, NRAID, nextPhoto, prevPhoto }: IDetailPageOpenSeaDragon) => {
  // prevent breaking errors
  if(typeof(photo) !== 'string') {
    photo = 'notfound';
  }
  // create dzi path and photo path for fallback
  let photoUrl = `${window.CDN_PATH}${auctionId}/${photo}`;
  let dziPath: false | string = `${window.CDN_PATH}${auctionId}/dzi/${photo.replace('.jpg', '.dzi')}`;
  if(photo === 'notfound') {
    // OSD component checks for photo === 'notfound'. don't append path or auction
    photoUrl = photo;
    dziPath = false;
  }
  return (
    <DetailPageOpenSeaDragonViewer photo={photoUrl} dzi={dziPath} navNext={nextPhoto} navPrev={prevPhoto}>
      {(NRAID && NRAID !== 'false' && NRAID !== '') && <NRAFFFOSDOverlay src={NRAFFFLogo} alt='NRAFFF LOGO' /> || ''}
    </DetailPageOpenSeaDragonViewer>
  );
};
